/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { AddFittingPopupModule } from './add-fitting-popup.module';
export { AddFittingPopupComponent } from './add-fitting-popup.component';